storefrontApp.service('elasticService', function () {
    this.buildProductInfoByIdsRequest = function (itemIds, size) {
        return (
            req = '{"track_total_hits": true, "query":{"ids":{"values":["' + itemIds + '"]}},"size":0,"aggs":{"products":{"top_hits":{"size":' + size +',"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","variants.width_in","variants.height_in","variants.variantId","itemId","isBuyable","definitionName","isClubOnly","productId"]}}}}}'
        )
    },
    this.buildProductInfoRequest = function (productId, hasMultiple) {
        if(hasMultiple){
            req = {
                query:
                {
                    "terms": {
                        _id: []
                    }
                }
            }
            productId.map(function(m){
                req.query.terms._id.push(m.toLowerCase())
            });
            return(
                req = (
                    JSON.stringify(req)
                )
            );
        }
        else{
            return (
                req = '{ "query": { "terms": { "_id": [ "' + productId + '" ] } } }'
            );
        }
    },

    this.buildAssociatedItemsRequest = function (associatedItems) {
        return (
            req = '{ "query": { "terms": { "_id":' + angular.toJson(associatedItems) + ' } }, "size": '+ associatedItems.length +' }'
        );
    },

    // eg. of Product ID - GN01-60020 - Case sensitive
    this.buildRelatedDesignItemsRequest = function(productId){
        return(
            req='{ "query": { "wildcard": { "variants.associatedItemsList": { "value": "' + productId.toLowerCase() +'" } } } }'
        );
    }

    this. buildOrderIdsQuery = function(productId) {
        if (angular.isDefined(productId)) {
            return JSON.stringify({
                size: 0, // no actual hits, only aggregation
                query: {
                    match: {
                        "productId.keyword": productId
                    }
                },
                aggs: {
                    distinct_orderIds: {
                        terms: {
                            field: "orderId.keyword",
                            size: 10000 // adjust as needed
                        }
                    }
                }
            });
        } else {
            return null;
        }
    },
    
    this.buildRelatedProductsQuery = function(orderIds, vendorIds, excludeProductId) {
        return JSON.stringify({
            size: 0,
            query: {
                bool: {
                    must: [
                        { terms: { "orderId.keyword": orderIds } },
                        { terms: { "catalogId.keyword": vendorIds } },
                        { terms: { "productDefinition.keyword": ["Font", "StockDesign","PrintArt","SVG"] } },
                        { range: { "extendedListPrice": { gt: 0 } } } 
                        
                    ],
                    must_not: [
                        { match: { "productId.keyword": excludeProductId } }
                    ]
                }
            },
            aggs: {
                frequently_bought_together: {
                    terms: {
                        field: "productId.keyword",
                        size: 2,
                        order: { "_count": "desc" }
                    }
                }
            }
        });
    }
});
